import { useTranslation } from 'react-i18next'
import { useLocation, Link, useNavigate } from 'react-router-dom'
import user from 'assets/images/user.svg'
import arrowDown from 'assets/images/arrowDown.svg'
import logout from 'assets/images/logout.svg'
import backIcon from 'assets/images/nav/back.svg'
import './NavBar.scss'
import { Menu, MenuButton, MenuList, MenuItem } from '@chakra-ui/react'
// import { setUserInfo } from 'redux/store/actions'
import { useDispatch, useSelector } from 'react-redux'

import { RootState } from 'redux/store/reducers'

interface ITitle {
  [key: string]: {
    title: string
    param?: string
    redirectLink?: string
  }
}
export default function NavBar(): JSX.Element {
  const { t, i18n } = useTranslation() // ti18n
  const location = useLocation()
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const userInfo = useSelector((state: RootState) => state.UserInfo.user)

  const lastParam =
    window.location.pathname.split('/')[window.location.pathname.split('/').length - 1]
  const Title: ITitle = {
    '/admin/users/create': { title: 'Add User', redirectLink: `/admin/users` },
    '/admin/hotelsUsers': { title: 'Hotels Owners' },
    '/admin/hotelsUsers/create': { title: 'Add Hotel Owner', redirectLink: `/admin/hotelsUsers` },
    '/admin/flight/flight-reservation/flight-gds': {
      title: 'Add Flight Reservation',
      redirectLink: `/admin/flight/AddReservation`,
    },
    '/admin/hotelsUsers/edit/': {
      title: 'edit port user',
      param: 'id',
      redirectLink: `/admin/hotelsUsers`,
    },
    '/admin/flight/flight-reservation/flight-gds/:id': {
      title: 'Add Flight Reservation',
      param: 'id',
      redirectLink: `/admin/flight/flight-reservation/flight-gds`,
    },
    '/admin/hotelsUsers/view/': {
      title: 'view port user',
      param: 'id',
      redirectLink: `/admin/hotelsUsers`,
    },
    '/admin/users': { title: 'Users' },
    '/admin/hotels': { title: 'Hotels' },
    '/admin/hotels/addHotel': { title: 'Add Hotel' },
    '/admin/hotels/AddReservation/hotels-gds': { title: 'Add Hotel Reservation' },
    '/admin/users/view/': { title: 'view port user', param: 'id', redirectLink: `/admin/users` },
    '/admin/users/edit/': { title: 'edit port user', param: 'id', redirectLink: `/admin/users` },
    '/admin/dashboard': { title: 'Dashboard', param: 'id' },
  }
  return (
    <div className="w-full bg-primary-50 print:hidden">
      <div className="flex justify-between items-center w-full py-3 px-1 ">
        <div className="w-6/12 flex items-center ">
          {Title[location.pathname]?.redirectLink && (
            <Link to={`${Title[location.pathname].redirectLink}`}>
              <img
                src={backIcon}
                alt="backIcon"
                className="w-5 rtl:rotate-180  h-5 object-contain me-2 "
              />
            </Link>
          )}
          {Title[location.pathname.replace(lastParam, '')] && (
            <Link to={`${Title[location.pathname.replace(lastParam, '')].redirectLink}`}>
              <img src={backIcon} alt="backIcon" className="w-5  h-5 object-contain me-2 " />
            </Link>
          )}
          <h1 className=" capitalize  text-[25px]  text-gray-700 font-light ">
            {Title[location.pathname]?.title?.length > 1
              ? t(Title[location.pathname].title)
              : t(Title[location.pathname.replace(lastParam, '')]?.title)}
          </h1>
        </div>

        <div className="w-2/4 flex justify-end ">
          <Menu>
            <div className="flex relative languageText items-center">
              {i18n.language === 'en' ? (
                <MenuButton
                  type="submit"
                  onClick={() => {
                    i18n.changeLanguage('ar')
                    localStorage.setItem('language', 'ar')
                  }}
                  // eslint-disable-next-line i18next/no-literal-string
                  className="text-[18px] languageFormat text-gray-700 mr-5 font-light">
                  العربيه
                </MenuButton>
              ) : (
                <MenuButton
                  type="submit"
                  onClick={() => {
                    i18n.changeLanguage('en')
                    localStorage.setItem('language', 'en')
                  }}
                  // eslint-disable-next-line i18next/no-literal-string
                  className="text-[18px] text-gray-700 mr-5 rtl:mr-0 rtl:ml-5 font-light">
                  EN
                </MenuButton>
              )}
            </div>
          </Menu>
          <Menu isLazy>
            <MenuButton>
              <div className="flex items-center ml-5">
                <img src={user} alt="user" className="w-7 h-7 mx-2" />
                <p className="text-xs truncate max-w-[200px] font-light">{userInfo?.userName}</p>
                <img src={arrowDown} alt="arrowDown" className="w-4 h-4 ms-2" />
              </div>
            </MenuButton>
            <MenuList>
              <MenuItem>
                <div className="flex w-full items-center">
                  <div className="flex px-2">
                    <img src={user} alt="user" className="w-8 h-8 " />
                  </div>
                </div>
              </MenuItem>
              <hr className="my-2 mx-4" />
              <MenuItem>
                <button
                  type="button"
                  onClick={() => {
                    localStorage.removeItem('user')
                    dispatch({ type: 'RESET_APP' })
                    // dispatch(setUserInfo(null))
                    navigate('/login')
                  }}
                  className="flex items-center  w-full">
                  <img src={logout} alt="logout" className="w-5 h-5 mx-2" />
                  <p className=" text-xs">{t('Logout')}</p>
                </button>
              </MenuItem>
            </MenuList>
          </Menu>
        </div>
      </div>
    </div>
  )
}
